/**
 * Settings Section Data
 *
 * Shared types and data for settings sections.
 * Used by Settings component (sidebar/drawer) and SettingsLandingPage (cards).
 */

/** Keys for main settings sections (excludes sub-sections like 'portfolio-instruments') */
export type SettingsSectionKey = 'preferences' | 'workflow' | 'strategies' | 'portfolio' | 'data-sync' | 'ai' | 'feedback-support' | 'profile';

/** Settings section definition for sidebar and landing page */
export interface SettingsSection {
  key: SettingsSectionKey;
  title: string;
  description: string;
}

/** Main settings sections data - shared between sidebar and landing page */
export const settingsSections: SettingsSection[] = [
  {
    key: 'preferences',
    title: 'App Preferences',
    description: 'Language, timezone, trading schedule'
  },
  {
    key: 'workflow',
    title: 'Trading Workflow',
    description: 'Pre-trading, live trading, post-trading settings'
  },
  {
    key: 'strategies',
    title: 'Trading Strategies',
    description: 'Strategies, playbooks, criteria, opportunities'
  },
  {
    key: 'portfolio',
    title: 'Trading Portfolio',
    description: 'Accounts, risk profiles, brokers, instruments'
  },
  {
    key: 'data-sync',
    title: 'Data & Sync',
    description: 'Storage location, sync settings, device management'
  },
  {
    key: 'ai',
    title: 'AI Assistant',
    description: 'AI provider, API key, model configuration'
  },
  {
    key: 'feedback-support',
    title: 'Feedback & Support',
    description: 'Support channel and third-party consent'
  },
  {
    key: 'profile',
    title: 'Profile Settings',
    description: 'Display name, email, password, licensing'
  }
];
